// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-tooltip {\n  border: 1px solid #c0c1c3 !important;\n  font-size: 14px;\n}\n.test-tooltip .popper__arrow {\n  border-style: inset !important;\n}\n", ""]);
// Exports
module.exports = exports;
